import { KTSVG, KTIcon, QUERIES } from '../../../../../../../_metronic/helpers'
import { useMutation, useQueryClient } from 'react-query'
import { updateUser } from '../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

const UserConfirmationDelete = ({ id, data, close, actionType }: any) => {
  const queryClient = useQueryClient()
  const { query } = useQueryResponse()
  const { pathname } = useLocation()
  const [showToastMsg, setShowToastMsg] = useState(false)
  const [remarks, setRemarks] = useState('')

  // Check if user is currently inactive
  console.log("actionType", actionType)
  const isInactive = actionType === 'ACTIVATE'
  const newStatus = isInactive ? 'ACTIVE' : 'INACTIVE'
  const actionText = isInactive ? 'activate' : 'deactivate'

  useEffect(() => {
    if (showToastMsg) {
      successToast(isInactive ? 'User activated successfully' : 'User deactivated successfully')
    }
  }, [showToastMsg, isInactive])

  const deleteItem = useMutation(
    () =>
      updateUser(
        remarks ? ({ remarks } as any) : ({ remarks: "" } as any),
        `user/${data?.id}/status?status=${newStatus}&type=${data?.userType || 'RECYCLER'}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
        successToast(isInactive ? 'User activated successfully' : 'User deactivated successfully')
        setShowToastMsg(true)
        close()
      },
    }
  )

  const userName = data?.personalDetails?.name

  const userContact = data?.personalDetails?.mobile
  console.log("data", data)
  return (
    <>
      <div
        className='modal fade show d-block'
        tabIndex={-1}
        role='dialog'
        aria-modal='true'
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.45)', backdropFilter: 'blur(3px)', zIndex: 1055 }}
        onClick={close}
      >
        <div
          className='modal-dialog modal-dialog-centered mw-550px'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='modal-content shadow-lg border-0 rounded-4 overflow-hidden'>
            {/* Modal Header */}
            <div className='modal-header border-0 pb-0 pt-6 px-7 justify-content-between align-items-center'>
              <h3 className='modal-title fw-bolder text-gray-900 fs-4'>
                {isInactive ? 'Activate User Account' : 'Deactivate User Account'}
              </h3>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary rounded-circle ms-2'
                aria-label='Close'
                onClick={close}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-1'
                />
              </div>
            </div>

            {/* Modal Body */}
            <div className='modal-body px-7 py-5'>
              {/* Status Badge Hero Icon */}
              <div className='text-center my-2'>
                <div
                  className={`d-inline-flex align-items-center justify-content-center rounded-circle mb-3 ${isInactive ? 'bg-light-success text-success' : 'bg-light-danger text-danger'
                    }`}
                  style={{ width: '64px', height: '64px' }}
                >
                  <KTIcon
                    iconName={isInactive ? 'user-tick' : 'user-cross'}
                    className={`fs-2x ${isInactive ? 'text-success' : 'text-danger'}`}
                  />
                </div>

                <h4 className='fw-bolder text-gray-800 mb-2 fs-5'>
                  Are you sure you want to {actionText} this user?
                </h4>
                <p className='text-muted fs-7 mb-4 px-4'>
                  {isInactive
                    ? 'Activating this account will restore user access and permissions.'
                    : 'Deactivating this account will temporarily restrict login access.'}
                </p>
              </div>

              {/* Target User Summary Card */}
              {data && (
                <div className='card bg-light border border-dashed border-gray-300 rounded-3 p-4 mb-4'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className={`symbol symbol-45px symbol-circle ${isInactive ? 'bg-light-danger text-danger' : 'bg-light-success text-success'
                          } d-flex align-items-center justify-content-center fw-bolder fs-5`}
                      >
                        {userName?.charAt(0)?.toUpperCase()}
                      </div>
                      <div>
                        <div className='fw-bolder text-gray-900 fs-6'>{userName}</div>
                        {userContact && <div className='text-muted fs-7'>{userContact}</div>}
                      </div>
                    </div>
                    <div>
                      <span
                        className={`badge ${isInactive ? 'badge-light-danger text-danger' : 'badge-light-success text-success'
                          } fw-bold px-3 py-2 fs-8`}
                      >
                        {data?.status || (isInactive ? 'INACTIVE' : 'ACTIVE')}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* Business Recycler Notice */}
              {pathname.includes('/apps/business/recycler') && (
                <div
                  className={`alert ${isInactive ? 'alert-success bg-light-success border-success' : 'alert-danger bg-light-danger border-danger'
                    } border border-dashed d-flex align-items-center p-3 mb-4 rounded-3`}
                >
                  <KTIcon
                    iconName='information-5'
                    className={`fs-2 me-3 ${isInactive ? 'text-success' : 'text-danger'}`}
                  />
                  <div className='text-gray-800 fs-7'>
                    {isInactive
                      ? 'This user will be able to log in again once activated.'
                      : 'This user will not be able to log in anymore once deactivated.'}
                  </div>
                </div>
              )}

              {/* Remark Input Field */}
              <div className='fv-row'>
                <label htmlFor='remarks' className='form-label fw-bold fs-6 text-gray-700 mb-2'>
                  Remark / Reason <span className='text-muted fs-7 fw-normal'>(Optional)</span>
                </label>
                <textarea
                  id='remarks'
                  className='form-control form-control-solid rounded-3 fs-7'
                  rows={2}
                  placeholder='Enter a reason or remark for this status change...'
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  disabled={deleteItem.isLoading}
                />
              </div>
            </div>

            {/* Modal Footer */}
            <div className='modal-footer border-0 pt-0 px-7 pb-6 justify-content-end gap-2'>
              <button
                type='button'
                onClick={close}
                className='btn btn-light btn-active-light-primary fw-bold px-6'
                disabled={deleteItem.isLoading}
              >
                Cancel
              </button>
              <button
                type='button'
                onClick={() => deleteItem.mutate()}
                className={`btn ${isInactive ? 'btn-success' : 'btn-danger'} fw-bold px-6 d-flex align-items-center`}
                disabled={deleteItem.isLoading}
              >
                {deleteItem.isLoading ? (
                  <>
                    <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                    <span>Processing...</span>
                  </>
                ) : (
                  <span>{isInactive ? 'Activate User' : 'Deactivate User'}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { UserConfirmationDelete }